import * as Dialog from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import clsx from 'clsx';
import React from 'react';

import AutoSuggest from '@/components/AutoSuggest/AutoSuggest.component';
import { IProps } from './GlobalSearch.interface';
import './GlobalSearch.styles.css';

export const GlobalSearch: React.FC<IProps> = ({
    className,
    open,
    onOpenChange,
    autoCompleteApiUrl,
    autoCompleteRedirectUrl,
    autoCompletePlaceholder,
    autoCompleteButtonText,
    autoCompleteMobilePlaceholder,
}) => {

    const isLocal = process.env.NODE_ENV === 'development' ? 'https://dev.missionaustralia.com.au' : '';

    const handleSearchSubmit = (searchTerm: string) => {
        if (!searchTerm.trim()) {
            return; // Prevent empty searches
        }
        window.location.href = `${isLocal}${autoCompleteRedirectUrl}${encodeURIComponent(searchTerm)}`;
    };

    const handleSuggestionSelected = (suggestion: string) => {
        if (!suggestion.trim()) {
            return; // Prevent empty suggestions
        }

        window.location.href = `${isLocal}${autoCompleteRedirectUrl}${encodeURIComponent(suggestion)}`;
    }
    return (
        <Dialog.Root open={open} onOpenChange={onOpenChange}>
            <Dialog.Portal>
                <Dialog.Overlay className="globalSearch__overlay" />
                <Dialog.Content className={clsx('globalSearch', className)}>
                    <AutoSuggest
                        name="globalSearch"
                        label="Global Search"
                        placeholder={autoCompletePlaceholder || 'Search...'}
                        apiUrl={autoCompleteApiUrl || ''}
                        onSearchSubmit={handleSearchSubmit}
                        onSuggestionSelect={handleSuggestionSelected}
                        initialValue={''}
                        buttonLabel={autoCompleteButtonText || 'Search'}
                        buttonLocation="internal"
                        viewAllCta={{
                            children: 'See all results',
                            className: 'globalSearch__viewAllCta',
                            variant: 'primary',
                            color: 'primary',
                            size: 'lg',
                            onClick: (e, currentQuery) => {
                                e.preventDefault();
                                if (currentQuery) {
                                    handleSearchSubmit(currentQuery);
                                }
                            },
                        }}
                        className="!hidden md:!flex"
                    />
                    <AutoSuggest
                        name="globalSearch"
                        label="Global Search"
                        placeholder={autoCompleteMobilePlaceholder || 'Search...'}
                        apiUrl={autoCompleteApiUrl || ''}
                        onSearchSubmit={handleSearchSubmit}
                        onSuggestionSelect={handleSuggestionSelected}
                        initialValue={''}
                        buttonLabel={autoCompleteButtonText || 'Search'}
                        buttonLocation="internal"
                        viewAllCta={{
                            children: 'See all results',
                            className: 'globalSearch__viewAllCta',
                            variant: 'primary',
                            color: 'primary',
                            size: 'lg',
                            onClick: (e, currentQuery) => {
                                e.preventDefault();
                                if (currentQuery) {
                                    handleSearchSubmit(currentQuery);
                                }
                            },
                        }}
                        className="!flex md:!hidden"
                    />
                    <Dialog.Close asChild>
                        <button className="globalSearch__closeButton" aria-label="Close">
                            <Cross2Icon />
                        </button>
                    </Dialog.Close>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
